export const ACTIVITY_SOURCE = {
  WILDERNESS: 'wilderness',
  JACADA: 'jacada',
};

// Related-option relation types, verbatim from the Wilderness pricing file's
// Related Options sheet ("Relation Type" column).
export const RELATION_TYPE = {
  MANDATORY: 'Mandatory',
  OPTIONAL: 'Optional',
};
